export default "__VITE_ASSET__C71WpWVl__"